export default __webpack_public_path__ + "static/media/subscription_icon.afb23f48.svg";